import KeenSlider from "keen-slider"
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';
import { areConsentsAccepted, enableScriptForConsents, loadScipt } from "layouts/js/scriptsManager"

	
const isMobileApp = location.href.includes('nb_mobile_app=1')

function showOCMInRead() {
	window?.OCM?.nbInread()
}

const vidAdsMapping = [{
	id: 241,
	group: [2, 3, 9, 23, 18],
}, {
	id: 909,
	group: [7, 8, 4, 15, 17, 53],
}, {
	id: 908,
	group: [11, 12, 14, 19, 20, 10, 28, 63],
}];


//inline ads
//deprecated
if (window.cmpData) {
	post3rdPartyScripts(window.cmpData);
} else {
	window.addEventListener('cmpChanged', post3rdPartyScripts);
}


function post3rdPartyScripts(e) { 	
	const purposes = e?.detail ?? {};

	const $article = document.getElementById("articleBody");
	
	if (!$article)
		return;

	const hideAds = $article.getAttribute('data-hideads') == "1";
	const mainCategoryID = $article.getAttribute('data-maincategoryid');
	const articleType = $article.getAttribute('data-articletype');
	const articleID = $article.getAttribute('data-id');

	//exitbee
	if (!hideAds && areConsentsAccepted(purposes, [1,2,7,9,10]) /* && window.innerWidth <= 768 */ && !isMobileApp) {
		(function (e, x, i, t, b) {
			e["ExitBeeObject"] = b; e[b] = e[b] ||
			function () { (e[b].args = e[b].args || []).push(arguments); };
			const a = x.createElement(i), m = x.getElementsByTagName(i)[0];
			a.async = 1; a.src = t; m.parentNode.insertBefore(a, m)
		})(window, document, "script", "https://cdn.exitbee.com/xtb.min.js", "xtb");
		window["xtb"]("loadSite", "7232");
	}

	//vidads
	if (!hideAds && areConsentsAccepted(purposes, [1,2,7,9,10]) && !isMobileApp && articleID!='11852539') {
		
		if (location.search.includes('enableVidAds')) {
			window["VidadsParser_loaded"] = () => {
				const filteredMap = vidAdsMapping.filter((I) => {
					return I.group.includes(Number(mainCategoryID));
				});
				
				let vidAdsCategoryID = filteredMap.length > 0 ? filteredMap[0].id : null;
				if (articleType == 'Advertorial')
					vidAdsCategoryID = 1;

				if (vidAdsCategoryID) {
					
					new VidadsVideo.Parser({
						youtube_image_filename: "hqdefault.jpg",
						vastUrl: `https://www.vidads.gr/get/video/vast3/${vidAdsCategoryID}`,
						fluid: true,
						beforeReplace: (el) => {
							if (el.getAttribute("data-src"))
								el.setAttribute("src", el.getAttribute('data-src'));
		
							return true;
						},
					});					
				}
			}

			loadScipt( 'https://www.vidads.gr/scripts/parser.min.js' );
		}
		
	}

	//phaistos
	if (!hideAds && areConsentsAccepted(purposes, [1,2,7,9,10]) && !isMobileApp) {
		enableScriptForConsents('phaistos');
	}

	//taboola
	if (!hideAds && areConsentsAccepted(purposes, []) && !isMobileApp) {
		enableScriptForConsents('agora');
	}

	if (!hideAds && !isMobileApp) {
		if (window?.OCM?.nbInread)
			window.OCM.nbInread();
		else 
			window.addEventListener('nbInreadReady', showOCMInRead );
	}
}


//event for GA
const $el = document.querySelector('.articleInRead[data-r]');
if ($el) {
	const type = $el.getAttribute("class").replace('articleInRead', '').replace('noPrint', '').trim();
	window.gtag && window.gtag('event', `inread_type_${type}`, {value: "1"});
}

class InPostGallery extends HTMLElement {

	slider = null;
	$keenSlider = null;
	$btnLeft = null;
	$btnRight = null;
	$lightBox = null;
	$btnExpand = null;
	tmp = null;

	constructor() {
        super();

		this.$keenSlider = this.querySelector('.keen-slider');

		this.$btnLeft = this.querySelector('.nbGalleryInPostNav.left');
		this.$btnRight = this.querySelector('.nbGalleryInPostNav.right');
		this.$btnExpand = this.querySelector('.nbGalleryEnlarge');

		if (this.$keenSlider) {
			this.init();
		}
	}

	init = () => {

		this.slider = new KeenSlider(
			this.$keenSlider, 
			{
				loop: true,
				slides: {
					perView: 1
				},
				created: () => {
					this.initLightBox();
				},
				slideChanged: () => {
					// const _idx = slider.track.details.rel;
					// this.$lnkArticles.forEach( el => el.classList.remove('active'));
					// this.$lnkArticles[_idx] && this.$lnkArticles[_idx].classList.add('active');

					
				}
			}
		)

		this.$btnLeft?.addEventListener('click', this.movePrev);
		this.$btnRight?.addEventListener('click', this.moveNext);
		this.$btnExpand?.addEventListener('click', this.onSlideClicked);

	}

	onSlideClicked = (e) => {
		e.preventDefault();

		if (this.$lightBox) {
			const _idx  =this.slider.track.details.rel || 0;
			this.$lightBox.loadAndOpen(_idx);
		}
	}

	initLightBox = () => {
		const galleryImages = [];
		this.$keenSlider.querySelectorAll('.keen-slider__slide').forEach( S => {

			const $I = S.querySelector('img');
			const $caption = S.querySelector('figcaption');

			galleryImages.push({
				src: $I.getAttribute('src'),
				width: Number( $I.getAttribute('width') ),
				height: Number( $I.getAttribute('height') ),
				alt: $caption ? $caption.textContent : ''
			});

		})

		if (this.$lightBox) 
			this.$lightBox.destroy();

		this.$lightBox = new PhotoSwipeLightbox({
			dataSource: galleryImages,
			bgOpacity: 0.9,
			pswpModule: () => import('photoswipe'),
		});

		this.$lightBox.on('uiRegister', () => {
			this.$lightBox.pswp.ui.registerElement({
				name: 'photoswipe-caption',
				order: 9,
				isButton: false,
				appendTo: 'root',
				html: '',
				onInit: (el, pswp) => {
					pswp.on('change', () => {
						const currSlideElement = pswp.currSlide.data;
						el.innerHTML = currSlideElement.alt || '';
					});
				}
			});
		});

  		this.$lightBox.init();
	}

	movePrev = () => {
		if (!this.slider)
			return;

		this.slider.prev();
	}

	moveNext = () => {
		if (!this.slider)
			return;

		this.slider.next();
	}

	disconnectedCallback() {

		if (this.slider) {
			this.slider.destroy();
		}

		if (this.$lightBox) {
			this.$lightBox.destroy();
			this.$lightBox = null;
		}
		
		this.$btnLeft?.removeEventListener('click', this.movePrev);
		this.$btnRight?.removeEventListener('click', this.moveNext);
		this.$btnExpand?.removeEventListener('click', this.onSlideClicked);
    }
}

if (!customElements.get("nb-gallery"))
	customElements.define("nb-gallery", InPostGallery);

//TOC
const $toc = document.querySelector('.articleBody .tocCnt');
if ($toc) {
	const $h2s = document.querySelectorAll('.articleBody h2');
	$h2s.forEach( $h => {
		$h.addEventListener("click", e => {
			e.preventDefault();
			$toc.scrollIntoView({ behavior: "smooth"});
		})
	})
}